import { ScrollArea } from "@Rolec-Services/rolec-ui";
import { cn } from "~/utils/utils";

export type TableProps = {
  info: { headings: React.ReactNode[]; content: React.ReactNode[] };
};

export function Table({ info }: TableProps) {
  const className =
    "text-sm bg-grey-200 text-center px-1 py-1 flex items-center justify-center";

  return (
    <ScrollArea className="flex flex-col justify-start gap-2 w-full lg:max-h-[280px] overflow-y-auto">
      <div className="grid grid-cols-3 w-full justify-between gap-2">
        {info.headings.map((node, index) => (
          <div
            className={cn(className, "bg-ev-500  text-white font-semibold")}
            key={index}
            children={node}
          />
        ))}
        {info.content.map((node, index) => (
          <div className={className} key={index} children={node} />
        ))}
      </div>
    </ScrollArea>
  );
}
